import { nomenclatureConstants } from '../_constants';

export function nomenclature(state = {}, action) {
  switch (action.type) {
    case nomenclatureConstants.COUNTRY_REQUEST:
      return {
        loading: true
      };
    case nomenclatureConstants.COUNTRY_SUCCESS:
      return {
        items: action.countrys
      };
    case nomenclatureConstants.COUNTRY_FAILURE:
      return { 
        error: action.error
      };
      case nomenclatureConstants.CATEGORYDOCENT_REQUEST:
        return {
          loading: true
        };
      case nomenclatureConstants.CATEGORYDOCENT_SUCCESS:
        return {
          items: action.categorys
        };
      case nomenclatureConstants.CATEGORYDOCENT_FAILURE:
        return { 
          error: action.error
        };
        case nomenclatureConstants.UNIVERSITIES_REQUEST:
            return {
              loading: true
            };
        case nomenclatureConstants.UNIVERSITIES_SUCCESS:
            return {
              items: action.universities
            };
        case nomenclatureConstants.UNIVERSITIES_FAILURE:
            return { 
              error: action.error
            };
    default:
        return state      
  }
}